import { MagicConfigMixin, FeatureEnabledV2, SessionChange } from '@gig/magic-common';
import { Mixins, Component } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { USER_JURISDICTION_UPDATED, USER_LOGGED_IN_UPDATED, USER_LOGIN_TIME_EVENT, Feature } from '@gig/magic-messages';
import { Jurisdiction } from '@gig/magic-jurisdictions';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let PanicBarComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.agcoBarShown = false;
    this.isLoggedIn = false;
    this.userLoginTime = 0;
    this.currentJurisdiction = null;
    this.jurisdictionSubscription = null;
    this.loggedInSubscription = null;
  }
  get isLOTBA() {
    return this.currentJurisdiction === Jurisdiction.LOTBA;
  }
  get isSGA() {
    return this.currentJurisdiction === Jurisdiction.SGA;
  }
  get isAGCO() {
    return this.currentJurisdiction === Jurisdiction.AGCO;
  }
  get isEMTA() {
    return this.currentJurisdiction === Jurisdiction.EMTA;
  }
  created() {
    this.jurisdictionSubscription = window.eventBus.subscribe(USER_JURISDICTION_UPDATED, (event) => {
      this.currentJurisdiction = event.payload;
    }, { replay: true });
    this.loggedInSubscription = window.eventBus.subscribe(USER_LOGGED_IN_UPDATED, (e) => {
      var _a;
      this.isLoggedIn = (_a = e.payload) != null ? _a : false;
    }, { replay: true });
  }
  destroyed() {
    var _a, _b;
    (_a = this.jurisdictionSubscription) == null ? void 0 : _a.unsubscribe();
    (_b = this.loggedInSubscription) == null ? void 0 : _b.unsubscribe();
  }
  getLoginTime(isLoggedIn) {
    const user = magic.session.getUser();
    if (!isLoggedIn || !user) {
      this.userLoginTime = 0;
      return;
    }
    const currentTime = Date.now();
    this.userLoginTime = user.lastVisit > currentTime ? currentTime : user.lastVisit;
    window.eventBus.publish(USER_LOGIN_TIME_EVENT, this.userLoginTime);
  }
};
__decorateClass([
  FeatureEnabledV2({
    slug: Feature.AGCO_TOP_BAR
  })
], PanicBarComponent.prototype, "agcoBarShown", 2);
__decorateClass([
  SessionChange({ immediate: true })
], PanicBarComponent.prototype, "getLoginTime", 1);
PanicBarComponent = __decorateClass([
  Component({
    name: "panic-bar"
  })
], PanicBarComponent);

export default PanicBarComponent;
